var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.useIubenda)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('AllInOneLegalCard')],1)],1):_c('v-row',_vm._l((_vm.topics),function(topic){return _c('v-col',{key:topic.slug,attrs:{"cols":"12","md":"6","lg":"4"}},[_c('legal-card',{attrs:{"item":topic,"is-external-link":topic.isExternalLink}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }